<div class="win">
    <div class="main">
        <h1>Permission Disabled</h1>
        <p>Please contact the competition administrators at <a href="mailto:{{email}}">{{email}}</a> to enable your permissions to {{compName}}.</p>
        <a href="mailto:{{email}}">Email administrator</a>
    </div>
  </div>
  